import React from 'react';

import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import { Trans } from 'react-i18next';
import { IconCompetencySolid } from '@pegasus/workforce-icons';
import { Image } from 'react-bootstrap';

import { individualState } from 'state/individual/individual-state';
import { FullScreenModal } from 'components/shared/FullScreenModal/FullScreenModal';
import { LoadingSpinner } from 'components/shared/LoadingSpinner/LoadingSpinner';

import './style.scss';

export const PaymentSuccessful = () => {
    const {t} = useTranslation();

    const newWorker = useRecoilValue(individualState);

    return (
        <FullScreenModal close={false}>
            {newWorker?.id ? (
                <div className="d-flex flex-column justify-content-center align-items-center">
                    <IconCompetencySolid className="CreateWorkerSuccess__checked-img text-success"/>
                    <h1 className="FullScreenModal__title">
                        {t('CreateWorkerSuccess.paymentSuccessful', 'Payment Successful')}
                    </h1>
                    <div className="CreateWorkerSuccess__description">
                        <p className="CreateWorkerSuccess__description-text text-center">
                            <Trans i18nKey="CreateWorkerSuccess.description">
                                You have successfully registered for an Individual Disability Skills Passport Worker
                                Profile. We have sent an email
                                to <strong>{{workerEmail: newWorker?.email}}</strong>. Please click the link in the
                                email to create your password. If you do not receive your email, please check your junk
                                folder.
                            </Trans>
                        </p>
                    </div>
                    {/* Removed for SSO */}
                    {/*<div className="CreateWorkerSuccess__buttons">*/}
                    {/*    <Button*/}
                    {/*        variant="primary"*/}
                    {/*        href={(window as any).ENV.REACT_APP_DSP_LOGIN}*/}
                    {/*        className="btn-xl CreateWorkerSuccess__button"*/}
                    {/*    >*/}
                    {/*        {t('CreateWorkerSuccess.actions.login', 'Log In')}*/}
                    {/*    </Button>*/}
                    {/*</div>*/}
                    <div className="CreateWorkerSuccess__logoDiv">
                        <a href={(window as any).ENV.REACT_APP_DSP_PORTAL_HOME}>
                            <Image src="/assets/images/DSP-Logo.svg" className="CreateWorkerSuccess__logo"/>
                        </a>
                    </div>
                    <div className="CreateWorkerSuccess__needHelp">
                        {t('CreateWorkerSuccess.needHelp', 'Need Help? Call Support on 1300 192 365')}
                    </div>
                </div>
            ) : (
                <LoadingSpinner/>
            )}
        </FullScreenModal>
    );
};
